var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLicensesActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "22px",
    viewBox: "0 0 17 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.944,0.00203159887 C10.21,-0.0149684011 10.486,0.0740315989 10.707,0.295031599 L16.707,6.2950316 C16.928,6.5160316 17.017,6.7920316 17,7.0580316 L17,19.5040316 C17,20.8830316 15.879,22.0020316 14.5,22.0020316 L2.5,22.0020316 C1.118,22.0020316 0,20.8820316 0,19.4990316 L0,2.5050316 C0,1.1250316 1.122,0.00203159887 2.496,0.00203159887 L9.944,0.00203159887 Z M9,2.0020316 L2.496,2.0020316 C2.227,2.0020316 2,2.2290316 2,2.5050316 L2,19.4990316 C2,19.7780316 2.224,20.0020316 2.5,20.0020316 L14.5,20.0020316 C14.775,20.0020316 15,19.7780316 15,19.5040316 L15,8.0020316 L10,8.0020316 C9.448,8.0020316 9,7.5540316 9,7.0020316 L9,2.0020316 Z M11,3.4160316 L11,6.0020316 L13.586,6.0020316 L11,3.4160316 Z M5,13.0020316 C4.448,13.0020316 4,12.5540316 4,12.0020316 C4,11.4500316 4.448,11.0020316 5,11.0020316 L12,11.0020316 C12.552,11.0020316 13,11.4500316 13,12.0020316 C13,12.5540316 12.552,13.0020316 12,13.0020316 L5,13.0020316 Z M5,17.0020316 C4.448,17.0020316 4,16.5540316 4,16.0020316 C4,15.4500316 4.448,15.0020316 5,15.0020316 L10,15.0020316 C10.552,15.0020316 11,15.4500316 11,16.0020316 C11,16.5540316 10.552,17.0020316 10,17.0020316 L5,17.0020316 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "03-Company",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24x24/ChartPie2"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#0067DF",
    xlinkHref: "#path-1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLicensesActive);
export default __webpack_public_path__ + "static/media/Licenses_Active.63eca65acec5bfad1aa39b07cd9f40bf.svg";
export { ForwardRef as ReactComponent };